import React from "react";
import { Users, Link2, Fingerprint, GitMerge } from "lucide-react";

export default function UnifiedProfileStep({
  connectedNames, mappedCount, identityLabels,
  title = "Step 5 — Unified Individual Profile",
  description = "Based on your connections, mappings, and identity rules so far, Data Cloud would generate one Unified Individual profile like this. Click \"Check My Work\" to have the AI validate your pipeline quality.",
  entityLabel = "Unified Individual",
  fieldUnitLabel = "DMO field",
}) {
  return (
    <div>
      <h3 className="font-heading font-semibold text-white mb-1">{title}</h3>
      <p className="text-sm text-slate-400 mb-4">{description}</p>
      <div className="glass-panel rounded-2xl p-6 border border-purple-400/20" data-testid="unified-profile-preview">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-11 h-11 rounded-full bg-purple-500/15 flex items-center justify-center">
            <Users className="w-5 h-5 text-purple-300" />
          </div>
          <div>
            <p className="text-sm font-semibold text-white">{entityLabel} — Preview</p>
            <p className="text-xs text-slate-400">Generated from your pipeline configuration</p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <div className="bg-white/[0.02] rounded-lg p-3">
            <p className="text-[10px] font-bold uppercase text-slate-400 flex items-center gap-1 mb-1"><Link2 className="w-3 h-3" /> Sources Merged</p>
            <p className="text-xs text-slate-300">{connectedNames.length ? connectedNames.join(", ") : "None connected yet"}</p>
          </div>
          <div className="bg-white/[0.02] rounded-lg p-3">
            <p className="text-[10px] font-bold uppercase text-slate-400 flex items-center gap-1 mb-1"><GitMerge className="w-3 h-3" /> Fields Mapped</p>
            <p className="text-xs text-slate-300">{mappedCount} {fieldUnitLabel}{mappedCount === 1 ? "" : "s"} populated</p>
          </div>
          <div className="bg-white/[0.02] rounded-lg p-3">
            <p className="text-[10px] font-bold uppercase text-slate-400 flex items-center gap-1 mb-1"><Fingerprint className="w-3 h-3" /> Identity Rules</p>
            <p className="text-xs text-slate-300">{identityLabels.length ? identityLabels.join(", ") : "None selected yet"}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
